import Vue from 'vue'
import router from './router'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import './permission' // 权限

// 公用方法
import utils from './utils/utils'
// 兼容性处理
import 'babel-polyfill'
// error log
import './components/ErrorLog/errorLog'
// 自定义指令
import './directive/index'
Vue.use(utils);
Vue.use(ElementUI);
Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js